import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
    const { user } = useAuth();
    const [cart, setCart] = useState({ items: [], subtotal: 0 });

    const refresh = useCallback(async () => {
        if (!user) {
            setCart({ items: [], subtotal: 0 });
            return;
        }
        try {
            const { data } = await api.get("/cart");
            setCart(data);
        } catch {
            setCart({ items: [], subtotal: 0 });
        }
    }, [user]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const add = async (product_id, quantity = 1) => {
        const { data } = await api.post("/cart/add", { product_id, quantity });
        setCart(data);
    };
    const update = async (product_id, quantity) => {
        const { data } = await api.post("/cart/update", { product_id, quantity });
        setCart(data);
    };
    const remove = async (product_id) => {
        const { data } = await api.delete(`/cart/remove/${product_id}`);
        setCart(data);
    };
    const clear = async () => {
        const { data } = await api.delete("/cart/clear");
        setCart(data);
    };

    return (
        <CartContext.Provider value={{ cart, refresh, add, update, remove, clear }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be inside CartProvider");
    return ctx;
}
